import { Button, Paper, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import DescriptionIcon from '@mui/icons-material/Description';
import useApiHook from "../hooks/useApiHook";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { Filesystem, Directory } from '@capacitor/filesystem';
import { FileOpener } from '@capawesome-team/capacitor-file-opener';
import useAppView from "./platforms/useAppView";

const Transcription = ({ transcription }) => {
    const { response, makeRequest, headers } = useApiHook();
    const { fileId } = useParams();
    const { isNativePlatform } = useAppView();
    const transcriptionObj = JSON.parse(transcription.transcription);
    const sentences = transcriptionObj.map(sentence => {
        return <Typography key={sentence.start} flexWrap={"wrap"} my={2} variant='body1'>{sentence.text}</Typography>;
    })
    const secondsTaken = Math.floor(transcription.timeTaken / 1000);

    const downloadTranscriptionClickHandler = (ext) => {
        makeRequest(`/file/${fileId}/tr_${transcription.id}/${ext}`, 'get', {}, { responseType: "blob" });
    }

    const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result
                    .replace('data:', '')
                    .replace(/^.+,/, '');
                resolve(base64String);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    useEffect(() => {
        if (response) {
            const fileName = `${headers['x-file-name']}.${headers['x-file-ext']}`;

            if (isNativePlatform) {
                blobToBase64(response).then(async (base64Data) => {
                    try {
                        // Salva nella cache privata dell'app (non richiede permessi)
                        const writeResult = await Filesystem.writeFile({
                            path: fileName,
                            data: base64Data,
                            directory: Directory.Cache,
                        });
                        // Apri il file con il visualizzatore di sistema
                        const mimeMap = {
                            'pdf': 'application/pdf',
                            'txt': 'text/plain',
                            'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        };
                        const ext = fileName.split('.').pop();
                        const mimeType = mimeMap[ext] || 'application/octet-stream';
                        await FileOpener.openFile({
                            path: writeResult.uri,
                            mimeType,
                        });
                    } catch (e) {
                        console.error("Errore apertura file", e);
                        alert("Errore durante il download o l'apertura del file.");
                    }
                });
            } else {
                const url = window.URL.createObjectURL(response);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    fileName,
                );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link.parentNode.removeChild(link);
            }
        }
    }, [headers, isNativePlatform, response]);

    return <Stack direction="column" spacing={1} flexGrow={1}>
        <Paper sx={{ p: 2 }} elevation={2}>
            <Typography mt={1} variant="body1">
                <b>Tempo impiegato: </b>
                {secondsTaken > 59 && `${Math.floor(secondsTaken / 60)} min `}
                {secondsTaken % 60} sec
            </Typography>
            <Typography mt={1} variant="body1">
                <b>Download:</b>
            </Typography>
            <Stack mt={1} direction='row' spacing={1}>
                <Button variant="outlined" color="error" startIcon={<PictureAsPdfIcon />} onClick={downloadTranscriptionClickHandler.bind(this, "pdf")}>
                    PDF
                </Button>
                <Button variant="outlined" color="error" startIcon={<FormatAlignLeftIcon />} onClick={downloadTranscriptionClickHandler.bind(this, "txt")}>
                    TXT
                </Button>
                <Button variant="outlined" color="error" startIcon={<DescriptionIcon />} onClick={downloadTranscriptionClickHandler.bind(this, "doc")}>
                    DOC
                </Button>
            </Stack>
        </Paper>
        <Paper elevetion={2}>
            <Box p={2}>
                {sentences}
            </Box>
        </Paper>
    </Stack>
}

export default Transcription;
